import { render, staticRenderFns } from "./ContentCreatorEditor.vue?vue&type=template&id=0745bbdf&scoped=true"
import script from "./ContentCreatorEditor.vue?vue&type=script&lang=js"
export * from "./ContentCreatorEditor.vue?vue&type=script&lang=js"
import style0 from "./ContentCreatorEditor.vue?vue&type=style&index=0&id=0745bbdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0745bbdf",
  null
  
)

export default component.exports